/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { DISPLAY_SNAPSHOT_FRAGMENT } from '@/graphql'

export const GET_DISPLAY_SNAPSHOTS = gql`
  query GetDisplaySnapshots(
    $filters: DisplaySnapshotFilter!
    $order: DisplaySnapshotOrder
    $pagination: OffsetPaginationInput
  ) {
    tenantDisplaySnapshots(
      filters: $filters
      order: $order
      pagination: $pagination
    ) {
      results {
        ...DisplaySnapshot
      }
      totalCount
    }
  }
  ${DISPLAY_SNAPSHOT_FRAGMENT}
`
